import { Component, Input, OnInit } from '@angular/core';
import { ColorSchemes } from 'src/styles/color-scheme.type';
import { FileSummaryData } from '../../models/file.data';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-files-list-in-summary',
  templateUrl: './files-list-in-summary.component.html',
  styleUrls: ['./files-list-in-summary.component.scss']
})
export class FilesListInSummaryComponent implements OnInit {
  @Input() files: FileSummaryData | null = null;
  @Input() photoMode: boolean = false;
  @Input() emptyText: string = this.ls.translate('label.empty');
  @Input() colors: ColorSchemes = ColorSchemes.PRIMARY;

  constructor(private ls: LocalizationService) {}

  ngOnInit(): void {}
}
